export default "__VITE_ASSET__CMbttL5s__"